import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../../../services/dashboard.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { SharedService } from '../../../../services/shared.service';

@Component({
  selector: 'app-images-blocco',
  templateUrl: './images-blocco.component.html',
  styleUrls: ['./images-blocco.component.css']
})
export class ImagesBloccoComponent implements OnInit {

  isLoading: boolean;
  blocco: any;
  tipo: string;

  constructor(
    private _dashboardService: DashboardService,
    private _sharedService: SharedService
  ) { }

  ngOnInit() {
  }

  inizializeForm() {
    this.getBlocco();
    this.isLoading = false;
  }

  getBlocco() {
    this.blocco = this._sharedService.getBlocco();
    this.tipo = this.blocco.tipoBlocco ? this.blocco.tipoBlocco : this.blocco.codiceBloccoTipo;
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-manager/images-blocco/images-blocco.component.ts